import getApi from '../../api/apisauceConfig'

export interface InteropPatientUrlResource {
  name: string
  url: string
}

export const getPatientInteropUrls = (patientId: number) =>
  getApi().get<InteropPatientUrlResource[]>(`/interop/patients/${patientId}/urls`)
